import { render, staticRenderFns } from "./PageTransactions.vue?vue&type=template&id=a29a004a&"
import script from "./PageTransactions.vue?vue&type=script&lang=js&"
export * from "./PageTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports